import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Noe gikk galt. Prøv igjen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Human-friendly message for network / timeout / offline errors (never leak internals).
export function friendlyError(err) {
  if (err?.code === "ECONNABORTED") return "Forespørselen tok for lang tid. Sjekk nettforbindelsen og prøv igjen.";
  if (err?.message === "Network Error" || (typeof navigator !== "undefined" && navigator.onLine === false))
    return "Ingen nettforbindelse. Sjekk internett og prøv igjen.";
  return formatApiErrorDetail(err?.response?.data?.detail);
}
